var _require = require('prettier/standalone'),
    concat = _require.doc.builders.concat;

var ExpressionStatement = {
  print: function print(_ref) {
    var node = _ref.node,
        path = _ref.path,
        _print = _ref.print;
    return concat([node.expression ? path.call(_print, 'expression') : '', node.omitSemicolon ? '' : ';']);
  }
};
module.exports = ExpressionStatement;